import { ILog, TrackingEventTypes, WorkerScope } from "./models";
import { dataIsInitObject, isObject, isUndefined, messageIsEvent } from "./helpers";

export const handleMessageBuilder = (worker: WorkerScope) => (message: MessageEvent) => {
    const event = message.data;
    if (messageIsEvent(event)) {
        switch (event.type) {
            case TrackingEventTypes.init:
                // Start
                if (isUndefined(worker.initObject)) {
                    if (dataIsInitObject(event.data)) {
                        worker.initObject = event.data;
                        // Success
                    } else {
                        worker.initLogger.error('Failed - click stream URL must be a string');

                    }
                } else {
                    // warn, already initialized
                    worker.initLogger.warn('Already initialized');
                }
                break;
            case TrackingEventTypes.log:
                if (isObject(event.data)) {
                    // Add log to queue
                    worker.logs.push({ ...event.data, retryCount: 0 } as ILog);
                } else {
                    worker.logLogger.warn('Log data should be an object', worker.initObject);

                }
                break;
            default:
                // log unsupported
                worker.mainLogger.warn('Unsupported event type', event);
                break;
        }
    } else {
        worker.mainLogger.warn('Unknown event format, please use {type: string, data: any}', event);
    }
}
